import React, { Component } from "react";
import { Link, Route } from "react-router-dom";
import {
	Search,
	DataTable,
	Loading,
	DataTableSkeleton,
	TextInput,
	TableContainer,
	Pagination,
	Form,
	FormLabel,
	FormGroup,
	TableHead,
	Table,
	DropdownSkeleton,
	TableSelectRow,
	DatePickerSkeleton,
	TableBatchActions,
	TableBatchAction,
	TableBody,
	TableRow,
	TableCell,
	TableHeader,
	TableToolbar,
	TableToolbarContent,
	Button,
} from "carbon-components-react";
import Edit16 from "@carbon/icons-react/lib/edit/16";
import Delete16 from "@carbon/icons-react/lib/delete/16";
import Send16 from "@carbon/icons-react/lib/send/16";
import { CheckmarkOutline16, CheckmarkFilled20, Add20, Error16, DocumentExport16, Download16 } from "@carbon/icons-react/lib/";
import moment, { invalid } from "moment";
import Data16 from "@carbon/icons-react/lib/data--1/16";
import { RenderDataTableCell, NoRecordsPlaceholder } from "../../helpers/jsonschemaform/DataTableExtention";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { getSuccess, getError, entitiesLabels, apioperation, DateFormat, STATUS } from "../../helpers/Constants";
import { incident, me, api } from "../../helpers/api/api";
import { ComboBox } from "../../helpers/ComboBox";
import { CanExecuteAction, IsInRole } from "../../helpers/authorization/Policies";
import { AppContext } from "../../helpers/context/AppContext";
import { WFActionModal } from "../common/WFActionModal";
import PageBreadCrumb from "../../helpers/PageBreadCrumb";
import DateTimePicker from "../../helpers/DateTimePicker";
import { Online, Offline } from "../common/OnLineOffLine";
import FileDownLoadButton from "../common/FileDownloadButton";
import IncidentRepository from "../../helpers/api/IncidentRepository";

export default class LandingGlobal extends Component {
	searchProp = () => ({
		incidentReportId: null,
		idStatus: null,
		idWorksite: null,
		idCountry: null,
		type: null,
		idPrj: null,
		idCompany: null,
		idMainDivision: null,
		inUse: null,
		occurredAt: null,
		investigationLevel: null,
		hcAlevel: null,/*NF ID: RITM1216061 || Task - 5  */
		compiler: null,
		dataApprover: null,
		divisionManager: null,
	});

	constructor(props) {
		super(props);

		this.state = {
			isApprovalModalOpen: false,
			approvalModalAction: "",
			approver: null,
			approvalStartDate: null,
			approvalEndDate: null,
			isLoadingApproverOptions: true,
			approvalValidationMessages: [],
			approvers: [],
			selectedData: [],
			approverRole: "",
			withApprover: true,
			isLoadingWFOperation: false,
			approvalNotesRequired: false,
			isLoadingNotificationFile: false,
			isLoadingReportFile: false,
			isLoading: true,
			isLoadingList: true,
			isLoadingStatus: true,
			isLoadingWorksite: true,
			isLoadingCountry: true,
			isLoadingProject: true,
			isLoadingCompany: true,
			isLoadingMainDivision: true,
			isLoadingDate: false,
			appWorkSiteName: [],
			itemList: [],
			currentPage: 1,
			pageSize: 10,
			rowCount: 0,
			status: [],
			worksite: [],
			country: [],
			xType: ["Accident", "Near Miss"],
			xInUse: ["In Use", "Not in use"],
			prj: [],
			company: [],
			//investigation: [
			//	{ id: "45f46ce6-3955-4e7e-91e2-1c3a576d53a5", name: "A" },
			//	{ id: "3a0e6c06-274b-456b-b54d-837123284021", name: "B" },
			//	{ id: "220e77aa-0ade-434d-9e57-baaa8f595b2a", name: "C" },
			//],
			/*NF ID: RITM1216061 || Task - 5 || Sub-Task-1 || Oindrila */
			hca: [
				{ id: 0, name: "0" },
				{ id: 1, name: "1" },
				{ id: 2, name: "2" },
				{ id: 3, name: "3" },
				{ id: 4, name: "4" },
				{ id: 5, name: "5" },

			],
			// actionstatus: [],
			maindivision: [],
			//ResetFilter
			isBack: this.props.history.action === "POP" || this.props.location.search === "?isBack" ? true : false,
			searchModel: {
				...this.searchProp(),
			},
			isConsolidationActionNo: false, //RITM1216061
		};
		this.toggleSearchForm = this.toggleSearchForm.bind(this);

		this.updateState = this.updateState.bind(this);
		this.handleClickCancelSearch = this.handleClickCancelSearch.bind(this);
		this.getStatus = this.getStatus.bind(this);
		this.getUserWorksite = this.getUserWorksite.bind(this);
		this.getCountry = this.getCountry.bind(this);
		this.getCompany = this.getCompany.bind(this);
		this.getIncidentList = this.getIncidentList.bind(this);

		this.IsRowSelectable = this.IsRowSelectable.bind(this);
	}

	componentDidMount() {
		this.getIncidentList();
		this.getCountry();
		this.getCompany();
		this.getPrj();
		this.getUserWorksite();
		this.getStatus();
		this.getUserDivision();
	}

	/** ***********API get all Incident******************* */
	getAll() {
		incident
			.getAll()
			.then((response) => {
				const { data } = response;

				this.setState({
					itemList: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingList: false,
				});
			});
	}

	getIncidentList = async (page, isNotBack) => {
		let data = null;
		if (!this.state.isBack || isNotBack) {
			data = {
				params: {
					...this.state.searchModel,
					page: this.state.currentPage,
					pageSize: this.state.pageSize,
				},
			};
			data.params.page = this.state.currentPage;
			data.params.pageSize = this.state.pageSize;
		} else {
			let filter = await IncidentRepository.getBackPaged();
			data = {
				params: filter?.params,
			};
			this.setState({
				searchModel: filter?.params,
				currentPage: 1, //RITM0549692
			});
			data.params.page = 1; //RITM0549692
			data.params.pageSize = filter?.params.pageSize;
			if (
				(filter?.params?.incidentReportId == undefined || filter?.params?.incidentReportId == "") &&
				filter?.params?.idStatus == undefined &&
				filter?.params?.idWorksite == undefined &&
				filter?.params?.idCountry == undefined &&
				filter?.params?.type == undefined &&
				filter?.params?.idPrj == undefined &&
				filter?.params.idCompany == undefined &&
				filter?.params?.idMainDivision == undefined &&
				filter?.params?.inUse == undefined &&
				filter?.params?.occurredAt == undefined &&
				//filter?.params?.investigationLevel == undefined &&
				/*NF ID: RITM1216061 || Task - 5 || Sub-Task-1 || Oindrila */
				filter?.params?.hcAlevel == undefined &&
				(filter?.params?.compiler == undefined || filter?.params?.compiler == "") &&
				filter?.params?.dataApprover == undefined &&
				filter?.params?.divisionManager == undefined
			)
				this.setState({ isOpenSearchForm: false });
			else this.setState({ isOpenSearchForm: true });
		}
		this.getIncidentListFilter(data);
	};

	getIncidentListFilter(data) {
		incident
			.getWithParam(data)
			.then((response) => {
				this.setState({
					...response.data,
				});
				IncidentRepository.updateReportFilter(data);
				IncidentRepository.updateReport(data);
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoading: false,
				});
			});
	}

	/** ***********API******************* */

	// Carico prop per combobox

	// Country
	getCountry = () => {
		api.getAll("/admin/country?page=0")
			.then((response) => {
				const data = response.data.itemList;
				this.setState({
					country: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.COUNTRY, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingCountry: false,
				});
			});
	};

	getPrj = () => {
		me.getAll("project")
			.then((response) => {
				const { data } = response;
				this.setState({
					prj: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingProject: false,
				});
			});
	};

	// COMPANY
	getCompany = () => {
		api.getAll("/admin/company?page=0")
			.then((response) => {
				const data = response.data.itemList;
				this.setState({
					company: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.COMPANY, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingCompany: false,
				});
			});
	};

	// STATUS
	getStatus = () => {
		api.getAll("/registry/status?page=0")
			.then((response) => {
				const { data } = response;
				this.setState({
					status: data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.STATUS, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingStatus: false,
				});
			});
	};

	// Division
	getUserDivision = () => {
		me.getAll("divisions")
			.then((response) => {
				this.setState({
					maindivision: response.data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.DIVISION, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingMainDivision: false,
				});
			});
	};

	// Worksite
	getUserWorksite = () => {
		me.getAll("worksites")
			.then((response) => {
				this.setState({
					worksite: response.data,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITEGROUP, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingWorksite: false,
				});
			});
	};

	updateState = (inputName, inputValue, objName) => {
		const statusCopy = { ...this.state };
		statusCopy[objName][inputName] = inputValue;
		statusCopy.isBack = false;
		this.setState(statusCopy);
	};

	// METODI VARI
	handleChangeCombo2 = (inputName, selectedItem, objName) => {
		let inputValue = selectedItem || null;
		if (inputName == "inUse") {
			if (inputValue == "In Use") inputValue = true;
			else if (inputValue == "Not in use") inputValue = false;
			else inputValue = null;
		}

		const statusCopy = { ...this.state };
		statusCopy[objName][inputName] = inputValue;
		statusCopy.isBack = false;
		// statusCopy['selectedItemCombo'][inputName] = selectedItem;
		this.setState(statusCopy);
	};

	handleChangeCombo = (inputName, selectedItem, objName) => {
		const inputValue = selectedItem ? selectedItem.id : null;
		const statusCopy = { ...this.state };
		statusCopy[objName][inputName] = inputValue;
		statusCopy.isBack = false;
		// statusCopy['selectedItemCombo'][inputName] = selectedItem;
		this.setState(statusCopy);
	};

	/** ***********Form Ricerca******************* */
	toggleSearchForm(e) {
		e.preventDefault();
		this.setState((oldState) => ({ isOpenSearchForm: !oldState.isOpenSearchForm, isConsolidationActionNo: false })); //RITM1216061 
	}

	handleChangeSearch = (el) => {
		const inputName = el.target.name;

		const inputValue = el.target.value;

		this.updateState(inputName, inputValue, "searchModel");
	};

	handleClickSearch = (e) => {
		e.preventDefault();
		this.setState({
			isConsolidationActionNo: false, //RITM1216061
			isLoading: true,
		});
		this.getIncidentList({ page: 1 }, true);
	};

	handleClickCancelSearch = () => {
		this.setState({
			isBack: false,
			isConsolidationActionNo: false, //RITM1216061
			isLoading: true,
			searchModel: {
				...this.searchProp(),
			},

			isOpenSearchForm: false,
		});
		let params = {
			page: 1,
			pageSize: 10,
			incidentReportId: null,
			idStatus: null,
			idWorksite: null,
			idCountry: null,
			type: null,
			idPrj: null,
			idCompany: null,
			idMainDivision: null,
			inUse: null,
			occurredAt: null,
			//investigationLevel: null,
			/*NF ID: RITM1216061 || Task - 5 || Sub-Task-1 || Oindrila */
			hcAlevel: null,
			compiler: null,
			dataApprover: null,
			divisionManager: null,
		};
		this.getIncidentListFilter({ params });
	};

	handleChangePaging = async (page) => {
		await new Promise((resolve) => {
			this.setState({ currentPage: page.page, pageSize: page.pageSize, loading: true, isLoading: true, isBack: false, isConsolidationActionNo: false }, resolve); //RITM1216061
		});
		this.getIncidentList();
	};

	updateStateDP = (inputName, inputValue, objName) => {
		this.setState((prevState) => ({
			[objName]: {
				...prevState[objName],
				[inputName]: inputValue,
				isBack: false,
			},
		}));
	};
	// COMPONENTE TENDINA TASTINO

	renderSearchform() {
		const filterItems = {
			idStatus: this.state.searchModel?.idStatus ? (this.state.status || []).find((el) => el.id === this.state.searchModel.idStatus) : [],
			idWorksite: this.state.searchModel?.idWorksite ? (this.state.worksite || []).find((el) => el.id === this.state.searchModel.idWorksite) : [],
			idCountry: this.state.searchModel?.idCountry ? (this.state.country || []).find((el) => el.id === this.state.searchModel.idCountry) : [],
			type: this.state.searchModel?.type ? this.state.searchModel.type : [],
			idPrj: this.state.searchModel?.idPrj ? (this.state.prj || []).find((el) => el.id === this.state.searchModel.idPrj) : [],
			idCompany: this.state.searchModel?.idCompany ? (this.state.company || []).find((el) => el.id === this.state.searchModel.idCompany) : [],
			idActionStatus: null,
			idMainDivision: this.state.searchModel?.idMainDivision ? (this.state.maindivision || []).find((el) => el.id === this.state.searchModel.idMainDivision) : [],
			inUse: this.state.searchModel?.inUse ? (this.state.searchModel.inUse ? "In Use" : "Not in use") : [],
			//investigationLevel: this.state.searchModel?.investigationLevel ? (this.state.investigation || []).find((el) => el.id === this.state.searchModel.investigationLevel) : [],
			/*NF ID: RITM1216061 || Task - 5 || Sub-Task-1 || Oindrila */
			hcAlevel: this.state.searchModel?.hcAlevel ? (this.state.hca || []).find((el) => el.id === this.state.searchModel.hcAlevel) : [],
		};
		return (
			<div>
				<Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class">Status</FormLabel>
						{this.state.isLoadingStatus ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								id="idSearchStatus"
								placeholder="All"
								name="idStatus"
								alt="searchModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.reportingName : "")}
								initialSelectedItem={this.state.searchModel.idStatus ? filterItems.idStatus : "All"}
								items={this.state.status}
							/>
						)}
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class">Worksite</FormLabel>
						{this.state.isLoadingWorksite ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								id="idSearchWorksite"
								placeholder="All"
								name="idWorksite"
								alt="searchModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={this.state.searchModel.idWorksite ? filterItems.idWorksite : "All"}
								items={this.state.worksite}
							/>
						)}
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class">Country</FormLabel>
						{this.state.isLoadingCountry ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								id="idSearchCountry"
								placeholder="All"
								name="idCountry"
								alt="searchModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={this.state.searchModel.idCountry ? filterItems.idCountry : "All"}
								items={this.state.country}
							/>
						)}
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class">Type</FormLabel>

						<ComboBox
							id="idSearchType"
							placeholder="All"
							name="type"
							alt="searchModel"
							onChange={this.handleChangeCombo2}
							itemToString={(item) => item || ""}
							initialSelectedItem={this.state.searchModel.type != null ? filterItems.type : "All"}
							items={this.state.xType}
						/>
					</FormGroup>

					{/* <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">
                            Reference Year
                                </FormLabel>
                        <ComboBox
                            id="idSearchReferenceYear"
                            placeholder="Select"
                            name="idReferenceYear"
                            alt="searchModel"
                            onChange={this.handleChangeCombo}
                            itemToString={item => (item ? item.name : '')}
                            initialSelectedItem={filterItems.idReferenceYear}
                            items={this.state.referenceyear}
                        //        // items={this.state.search.search}

                        />
                    </FormGroup> */}

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class">Project</FormLabel>
						{this.state.isLoadingProject ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								id="idSearchPrj"
								placeholder="All"
								name="idPrj"
								alt="searchModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={this.state.searchModel.idPrj ? filterItems.idPrj : "All"}
								items={this.state.prj}
							/>
						)}
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class">Operating Company Branch</FormLabel>
						{this.state.isLoadingCompany ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								id="idSearchCompany"
								placeholder="All"
								name="idCompany"
								alt="searchModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={this.state.searchModel.idCompany ? filterItems.idCompany : "All"}
								items={this.state.company}
							/>
						)}
					</FormGroup>

					{/* <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">
                            Corrective / Preventing Action Status
                                </FormLabel>
                        <ComboBox
                            id="idSearchActionStatus"
                            placeholder="Select"
                            name="idActionStatus"
                            alt="searchModel"
                            onChange={this.handleChangeCombo}
                            itemToString={item => (item ? item.name : '')}
                            initialSelectedItem={filterItems.idActionStatus}
                            items={this.state.actionstatus}
                        //        // items={this.state.search.search}

                        />
                    </FormGroup> */}
					{/* 
                    <FormGroup legendText="" className="bx--col-md-4">
                        <FormLabel className="some-class">
                            Quarter
                                </FormLabel>
                        <ComboBox
                            id="idSearchQuarter"
                            placeholder="Select"
                            name="idQuarter"
                            alt="searchModel"
                            onChange={this.handleChangeCombo}
                            itemToString={item => (item ? item.name : '')}
                            initialSelectedItem={filterItems.idQuarter}
                            items={this.state.quarter}
                        //        // items={this.state.search.search}

                        />
                    </FormGroup> */}

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						{/* RITM0945977 */}
						{/* <FormLabel className="some-class">Main Division</FormLabel> */}
						<FormLabel className="some-class">Main Business Line</FormLabel>
						{this.state.isLoadingMainDivision ? (
							<DropdownSkeleton />
						) : (
							<ComboBox
								id="idSearchMainDivision"
								placeholder="All"
								name="idMainDivision"
								alt="searchModel"
								onChange={this.handleChangeCombo}
								itemToString={(item) => (item ? item.name : "")}
								initialSelectedItem={this.state.searchModel.idMainDivision ? filterItems.idMainDivision : "All"}
								items={this.state.maindivision}
							/>
						)}
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class">Worksite / Prj In Use</FormLabel>
						<ComboBox
							id="idSearchInUse"
							placeholder="All"
							name="inUse"
							alt="searchModel"
							onChange={this.handleChangeCombo2}
							itemToString={(item) => item || ""}
							initialSelectedItem={this.state.searchModel.inUse != null ? filterItems.inUse : "All"}
							items={this.state.xInUse}
						/>
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel className="some-class">Date Of Occurrence</FormLabel>
						{this.state.isLoadingDate ? (
							<DatePickerSkeleton />
						) : (
							<DateTimePicker
								value={this.state.searchModel.occurredAt}
								type="date"
								placeholder={DateFormat}
								name="occurredAt"
								alt="searchModel"
								// invalid={validations.occurrenceTime != null}
								onChange={this.updateStateDP}
								disabled={this.state.isDisabled}
							/>
						)}
					</FormGroup>
					{ /*NF ID: RITM1216061 || Task - 5 || Sub-Task-1 || Oindrila */}
					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
                        <FormLabel className="some-class">HCA Level</FormLabel>
                        <ComboBox
                            id="hcAlevel"
                            placeholder="All"
                            name="hcAlevel"
                            alt="searchModel"
                            onChange={this.handleChangeCombo}
                            itemToString={(item) => (item ? item.name : "")}
                            initialSelectedItem={this.state.searchModel.hcAlevel ? filterItems.hcAlevel : "All"}
                            items={this.state.hca}
                        />
                    </FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel>Incident Code</FormLabel>
						<TextInput
							id="inputcodesearch"
							name="incidentReportId"
							value={this.state.searchModel?.incidentReportId != null ? this.state.searchModel.incidentReportId : ""}
							onChange={this.handleChangeSearch}
							placeholder="Input Incident Code"
							type="text"
							labelText=""
							className="bx--text-input some-class bx--text-input--light"
						/>
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel>Email Compiler</FormLabel>
						<TextInput
							id="inputsearchcompiler"
							name="compiler"
							value={this.state.searchModel?.compiler != null ? this.state.searchModel.compiler : ""}
							onChange={this.handleChangeSearch}
							placeholder="Input Compiler"
							type="text"
							labelText=""
							className="bx--text-input some-class bx--text-input--light"
						/>
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel>Email Data Approver</FormLabel>
						<TextInput
							id="inputsearchdataApprover"
							name="dataApprover"
							value={this.state.searchModel?.dataApprover != null ? this.state.searchModel.dataApprover : ""}
							onChange={this.handleChangeSearch}
							placeholder="Input Data Approver"
							type="text"
							labelText=""
							className="bx--text-input some-class bx--text-input--light"
						/>
					</FormGroup>

					<FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4">
						<FormLabel>Email Consolidator</FormLabel>
						<TextInput
							id="inputsearchdivisionManager"
							name="divisionManager"
							value={this.state.searchModel.divisionManager || ""}
							onChange={this.handleChangeSearch}
							placeholder="Input Consolidator"
							type="text"
							labelText=""
							className="bx--text-input some-class bx--text-input--light"
						/>
					</FormGroup>
				</Form>
				<div className="searchFormFooter">
					<Button className="button--max-width" size="small" kind="secondary" onClick={this.handleClickCancelSearch}>
						Cancel
					</Button>
					<Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
						Search
					</Button>
				</div>
			</div>
		);
	}

	handleApproverSelect = (selectedItem) => {
		this.setState({ approver: selectedItem });
	};

	handleCloseApprovalModal = () => {
		this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
	};

	//RITM1216061
	handleCancelApprovalModal = () => {
		this.setState({ isApprovalModalOpen: false, approver: null, isConsolidationActionNo: (((this.state.selectedData[0]?.cells[10]?.value != null && this.state.selectedData[0]?.cells[10]?.value <= 1) 
			|| ((this.state.selectedData[0]?.cells[11]?.value == 'Commuting' && this.state.selectedData[0]?.cells[10]?.value != null && this.state.selectedData[0]?.cells[10]?.value > 1 && this.state.selectedData[0]?.cells[10]?.value < 4))) 
			&& (this.state.approvalModalAction == 'Consolidate' || this.state.approvalModalAction == 'Submit') && this.state.selectedData[0]?.cells[0]?.value == 'Opened' ? true : false)}, this.clearApprovalForm); //RITM1468542 RITM1420951
	};
	//End

	handleApprovalNotesChange = (e) => {
		this.setState({ approvalNotes: e.target.value });
	};

	handleConfirmApprovalModal = () => {
		const action = this.state.approvalModalAction.toLowerCase();
		const apiEndpoint = this.state.approvalEndpoint;
		const data = {
			ids: this.state.selectedData.map((r) => r.id),
			owner: this.state.approver,
			workflowNotes: this.state.approvalNotes,
		};
		var incidentCode = [];
		var incidentReportIdCode = "";
		data.ids.forEach((item) => incidentCode.push(this.state.itemList.find((el) => el.id == item)));
		incidentCode.forEach((item) => (incidentReportIdCode = incidentReportIdCode + item.incidentReportId + ", "));
		if (data.ids.length > 1) {
			var incidentNum = "Incidents";
		} else {
			var incidentNum = entitiesLabels.INCIDENT;
		}
		this.setState({
			isLoadingWFOperation: true,
		});
		api.put(`/incident/${apiEndpoint}`, data, "")
			.then((response) => {
				if (response.status === 200) {
					showNotification.success(`${entitiesLabels.SUCCESS}`, `${incidentNum} ${entitiesLabels.WITHCODE} ${getSuccess(incidentReportIdCode, apiEndpoint)}`);
					this.setState({
						isLoadingWFOperation: false,
						isApprovalModalOpen: false,
						isConsolidationActionNo: false, //RITM1216061
						isLoading: true,
						itemList: [],
					});
					this.getIncidentList();
				} else {
					showNotification.error();
					this.setState({
						isLoadingWFOperation: false,
					});
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT, apioperation.PUT));
				this.setState({
					isLoadingWFOperation: false,
				});
			})
			.finally(() => {
				this.state.approver = null;
			});
	};

	getUsersInRole = (role, appModule, idWorksite, idDivision) => { //RITM1064131
		me.getWithParam("getuserbyroleandmodule", { //RITM1064131
			params: { Role: role, appModule: appModule, idWorksites: idWorksite, IdDivision: idDivision, includeAdmins: true }, //RITM1064131
		})
			.then((response) => {
				this.setState({
					approvers: response.data,
					isLoadingApproverOptions: false,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.ROLE, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingApproverOptions: false,
				});
			});
	};

	IsRowSelectable(tableRow, selectedRows, user) {
		const row = this.state.itemList.find((i) => i.id == tableRow.id);
	
		if (row.idStatus == STATUS.Consolidated && row.isReopen == 0) return false; //RITM1216061
				
			if (selectedRows.length == 0) {
				
				if (row.idStatus == STATUS.Consolidated 
					&& user.roles.includes('Administrator') && row.isReopen == 1) return true; //RITM1216061 

				const canSelect =
					CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Submit", row) ||
					CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Approve", row) ||
					CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Consolidate", row) ||
					CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Reject", row) ||
					CanExecuteAction("Incident", "Reporting", user, row.idStatus, "RejectConsolidate", row) ||
					CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Delete", row);
				return canSelect;
			}
	
			if (selectedRows.length > 0) {
				const selectableIncident = this.state.itemList.find((i) => i.id == selectedRows[0].id);
				const selectableState = selectableIncident.idStatus;
				const selectableDivision = selectableIncident.idDivision;
				const selectableWorksite = selectableIncident.idWorksite;
				const selectableAHLPHLFinalLevel01 = selectableIncident.ahLorPHLFinalLevel0or1; //RITM1216061
				const selectableIsReopen = selectableIncident.isReopen; //RITM1216061
				const selectableWorkRelated = selectableIncident.workRelated; //RITM1420951

				if (row.idStatus == selectableState && (row.ahLorPHLFinalLevel0or1 !== null && ((row.ahLorPHLFinalLevel0or1 <= 1) || (row.workRelated == 'Commuting' && row.ahLorPHLFinalLevel0or1 > 1 && row.ahLorPHLFinalLevel0or1 < 4))) && row.idStatus == STATUS.Draft && row.idWorksite == selectableWorksite) {//RITM1216061 RITM1420951
					const canSelect =
						CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Submit", row) ||
						CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Consolidate", row) ||
						CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Delete", row);
					return canSelect;
				}
				else if (row.idStatus == STATUS.Consolidated && row.idStatus == selectableState && row.isReopen == 1 && row.isReopen == selectableIsReopen && user.roles.includes('Administrator')) //RITM1216061
					return true;
				else if (row.idStatus == selectableState && (((row.ahLorPHLFinalLevel0or1 == null || (row.ahLorPHLFinalLevel0or1 > 3 || (row.workRelated !== 'Commuting' && row.ahLorPHLFinalLevel0or1 > 1 && row.ahLorPHLFinalLevel0or1 < 4)))
					&& (selectableAHLPHLFinalLevel01 == null || (selectableAHLPHLFinalLevel01 != 0 && selectableAHLPHLFinalLevel01 != 1 && selectableAHLPHLFinalLevel01 > 3) || (selectableAHLPHLFinalLevel01 > 1 && selectableAHLPHLFinalLevel01 < 4 && selectableWorkRelated != 'Commuting')) && row.idStatus == STATUS.Draft)
					|| ((row.ahLorPHLFinalLevel0or1 == null || (row.ahLorPHLFinalLevel0or1 > 3 || (row.workRelated !== 'Commuting' && row.ahLorPHLFinalLevel0or1 > 1 && row.ahLorPHLFinalLevel0or1 < 4))) && row.idStatus > STATUS.Draft)
					|| ((row.ahLorPHLFinalLevel0or1 != null && ((row.ahLorPHLFinalLevel0or1 <= 1) || (row.workRelated == 'Commuting' && row.ahLorPHLFinalLevel0or1 > 1 && row.ahLorPHLFinalLevel0or1 < 4))) && row.idStatus > STATUS.Draft))
					&& (row.idStatus == STATUS.Draft ? row.idWorksite == selectableWorksite : row.idDivision == selectableDivision)) { //RITM1216061 RITM1420951
					const canSelect =
						CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Submit", row) ||
						CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Approve", row) ||
						CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Consolidate", row) ||
						CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Reject", row) ||
						CanExecuteAction("Incident", "Reporting", user, row.idStatus, "RejectConsolidate", row) ||
						CanExecuteAction("Incident", "Reporting", user, row.idStatus, "Delete", row);
					return canSelect;
					// return true;
				}
	
				return false;
			}
	
			return false;
	}

	downloadFile() {
		if (this.state.isExportLoading) return;

		this.setState({
			isExportLoading: true,
		});
		api.getWithParam("/incident/excel", { responseType: "arraybuffer" })
			.then((response) => {
				// fileDownload(new Blob([response.data]), 'report.xlsx');
				const data = new Blob([response.data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});
				const csvURL = window.URL.createObjectURL(data);
				const tempLink = document.createElement("a");
				tempLink.href = csvURL;

				const nomefile = `${"Export_" + "Incident_"}${moment().format("YYYYMMDDHHmmSS")}.xlsx`;
				tempLink.setAttribute("download", nomefile);

				document.body.appendChild(tempLink);
				tempLink.click();
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "Download File", apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isExportLoading: false,
				});
			});
	}

	DownloadNotification(incidentId) {
		this.setState({ isLoadingNotificationFile: true });
		incident
			.downloadNotification(incidentId, { responseType: "arraybuffer" })
			.then((response) => {
				const data = new Blob([response.data], { type: "application/pdf" });
				const csvURL = window.URL.createObjectURL(data);
				const tempLink = document.createElement("a");
				tempLink.href = csvURL;
				const incidentCode = this.state.itemList.find((i) => i.id == incidentId);
				const nomefile = `Incident_Notification_${incidentCode.incidentReportId}.pdf`;
				tempLink.setAttribute("download", nomefile);
				document.body.appendChild(tempLink);
				tempLink.click();
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT_NOTIFICATION, apioperation.DOWNLOAD));
			})
			.finally(() => {
				this.setState({ isLoadingNotificationFile: false });
			});
	}

	DownloadReport(incidentId) {
		this.setState({ isLoadingReportFile: true });
		incident
			.downloadReport(incidentId, { responseType: "arraybuffer" })
			.then((response) => {
				const data = new Blob([response.data], { type: "application/pdf" });
				const csvURL = window.URL.createObjectURL(data);
				const tempLink = document.createElement("a");
				tempLink.href = csvURL;
				const incidentCode = this.state.itemList.find((i) => i.id == incidentId);
				const nomefile = `Incident_Report_${incidentCode.incidentReportId}.pdf`;
				tempLink.setAttribute("download", nomefile);
				document.body.appendChild(tempLink);
				tempLink.click();
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT_REPORT, apioperation.DOWNLOAD));
			})
			.finally(() => {
				this.setState({ isLoadingReportFile: false });
			});
	}

	batchActionClick(actionKey, actionName, approverRole, withApprover, approvalNotesRequired, selectedRows) {
		const incident = this.state.itemList.find((i) => i.id == selectedRows[0].id);

		//RITM1519246
		if (!approvalNotesRequired && actionName != 'Delete' && (incident.realOutcomeHarm != null || incident.realOutcomeEnvironmental != null))
		{
			const ok = window.confirm("Do you confirm the HCA levels (AHC, PHCwc, PHCf) and the analysed safeguards (effective and inadequate)? Please before proceeding check the values in Notification tab");
 		    if (!ok) return;
		}
		//End

		var idWorksite = actionKey === 'Submit' ? incident.idWorksite : null; //RITM1064131
		var idDivision = actionKey === 'Approve' ? incident.idDivision : null; //RITM1064131

		this.setState({
			approvalModalAction: actionName,
			isApprovalModalOpen: true,
			isLoadingApproverOptions: true,
			withApprover,
			selectedData: selectedRows,
			approverRole,
			approvalEndpoint: actionKey,
			approvalNotesRequired,
			isConsolidationActionNo: actionKey =='Consolidate' ? false : this.state.isConsolidationActionNo, //RITM1216061
		});

		if (withApprover) this.getUsersInRole(approverRole, 'Incident', idWorksite, idDivision); //RITM1064131
	}

	getIncident = (selectedRows) => {
		if (selectedRows && selectedRows.length > 0) {
			return this.state.itemList.find((el) => el.id == selectedRows[0].id);
		}
		return null;
	};

	getStatusId = (idRow) => {
		const r = this.state.itemList.find((el) => el.id == idRow);
		return r && r.idStatus;
	};

	/** ***********Render******************* */
	getIncidentNotificationCode = (id) => {
		const incidentCode = this.state.itemList.find((el) => el.id == id);
		return "Incident_Notification_" + incidentCode.incidentReportId + ".pdf";
	};
	getIncidentReportCode = (id) => {
		const incidentCode = this.state.itemList.find((el) => el.id == id);
		return "Incident_Report_" + incidentCode.incidentReportId + ".pdf";
	};
	render() {
		const headersDataTable = [
			{ key: "status", header: "Status", type: "status" },
			{ key: "incidentReportId", header: "Code" },
			//RITM0945977
			// { key: "division", header: "Division" },
			{ key: "division", header: "Business Line" },
			{ key: "worksite", header: "Worksite" },
			{ key: "title", header: "Title" },
			{ key: "occurrenceDate", header: "Occurence Date", type: "date" },
			{ key: "type", header: "Type" },
			{ key: "outcome", header: "Outcome" },
			//{ key: "investigationLevel", header: "Investigation Level" }, //RITM1216061
			{ key: "hcAlevel", header: "HCA Level" }, //RITM1216061	
			{ key: "isReopen", header: "IsReopen", visible: "false" }, //RITM1216061
			{ key: "ahLorPHLFinalLevel0or1", header: "ahLorPHLFinalLevel0or1", visible: "false" }, //RITM1216061
			{ key: "workRelated", header: "workRelated", visible: "false" }, //RITM1420951
		];

		const paginationProps = () => ({
			page: this.state.currentPage || 1,
			totalItems: this.state.rowCount || 0,
			pageSize: this.state.pageSize || 10,
			pageSizes: [10, 20, 30, 40, 50],
			onChange: this.handleChangePaging,
		});

		const skeletonRowCount = this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount ? this.state.rowCount : 5;

		return (
			<AppContext.Consumer>
				{({ user }) => (
					<>
						<PageBreadCrumb linkTo="/modules" linkText="Modules" titleLeft="Incidents" />
						<div className="mainContainer">
							<Loading active={this.state.isLoadingNotificationFile || this.state.isLoadingReportFile} withOverlay />
							<WFActionModal
								show={this.state.isApprovalModalOpen}
								title={`${this.state.approvalModalAction} Incidents`}
								action={this.state.approvalModalAction}
								withApprover={this.state.withApprover}
								approver={this.state.approver}
								approverRole={this.state.approverRole}
								approverOptions={this.state.approvers}
								isLoadingOperation={this.state.isLoadingWFOperation}
								onApproverSelect={this.handleApproverSelect}
								isLoadingOptions={this.state.isLoadingApproverOptions}
								onCancel={this.handleCancelApprovalModal} //RITM1216061
								onConfirm={this.handleConfirmApprovalModal}
								onApprovalNotesChange={this.handleApprovalNotesChange}
								approvalNotes={this.state.approvalNotes}
								approvalNotesRequired={this.state.approvalNotesRequired}
								validationMessages={this.state.approvalValidationMessages}
								customMessage={(((this.state.selectedData[0]?.cells[10]?.value != null && (this.state.selectedData[0]?.cells[10]?.value == 0 || this.state.selectedData[0]?.cells[10]?.value == 1)) 
									|| ((this.state.selectedData[0]?.cells[11]?.value == 'Commuting' && this.state.selectedData[0]?.cells[10]?.value != null && this.state.selectedData[0]?.cells[10]?.value > 1 && this.state.selectedData[0]?.cells[10]?.value < 4)))
									&& this.state.selectedData[0]?.cells[0]?.value == 'Opened' && this.state.approvalModalAction == 'Consolidate') ? `Do you want to complete without Incident Investigation?` : null} //RITM1216061 RITM1420951
								customMessage2={(((this.state.selectedData[0]?.cells[10]?.value != null && (this.state.selectedData[0]?.cells[10]?.value == 0 || this.state.selectedData[0]?.cells[10]?.value == 1)) 
									|| ((this.state.selectedData[0]?.cells[11]?.value == 'Commuting' && this.state.selectedData[0]?.cells[10]?.value != null && this.state.selectedData[0]?.cells[10]?.value > 1 && this.state.selectedData[0]?.cells[10]?.value < 4)))
									&& this.state.selectedData[0]?.cells[0]?.value == 'Opened' && this.state.approvalModalAction == 'Consolidate') ? `NOTE: Investigation report is not required for PHCf_people/PHCf_env 0-1 and for Commuting Events with PHCf_People/PHCf Env 0,1,2,3\nif confirm is clicked, report will be completed without distribution\nif cancel is clicked, the usual full investigation report will be enabled` : null} //RITM1216061 RITM1420951
								module={'Incident'} //RITM1216061
								onClose={this.handleCloseApprovalModal} //RITM1216061
							/>

							<TableToolbar>
								<Search readOnly light className="search cursor-pointer hiddenSearch" labelText="Search" placeHolderText="Search" id="search-1" onClick={this.toggleSearchForm} />
								<Button onClick={this.toggleSearchForm} className="buttonPaddingIcon" renderIcon={Data16} iconDescription="Filter" />
								<Online>
									<FileDownLoadButton
										onError={(error) => {
											showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "Download File", apioperation.GET));
										}}
										onDownLoadStart={() => this.setState({ isExportLoading: true })}
										onDownLoadEnd={() => this.setState({ isExportLoading: false })}
										apiUrl="/incident/excel"
										fileName={`${"Export_Incident_"}${moment().format("YYYYMMDDHHmmSS")}.xlsx`}
										className="btn-notext"
										iconDescription=" "
										renderIcon={Download16}
									>
										{!this.state.isExportLoading ? "" : <Loading />}
									</FileDownLoadButton>
								</Online>
								{IsInRole(user, "Administrator") || IsInRole(user, "Compiler") || IsInRole(user, "Data Approver") ? ( //RITM1064131
									<Link to="/incident/new">
										<Button renderIcon={Add20}>New </Button>
									</Link>
								) : null}
							</TableToolbar>

							{!this.state.isOpenSearchForm ? "" : this.renderSearchform()}

							<DataTable
								rows={this.state.itemList || []}
								headers={headersDataTable}
								useZebraStyles
								size="compact"
								render={({ rows, headers, getHeaderProps, getRowProps, getTableProps, getSelectionProps, selectedRows, getBatchActionProps }) => (
									<TableContainer className="bx--grid--full-width" title="">
										{selectedRows.length > 0 ? (
											<Online>
												<TableToolbar>
													<TableToolbarContent>
														<TableBatchActions {...getBatchActionProps()}>
															{(CanExecuteAction(
																"Incident",
																"Reporting",
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Submit",
																this.getIncident(selectedRows)
															) && (!((selectedRows[0].cells[10].value !== null && (selectedRows[0].cells[10].value == 0 || selectedRows[0].cells[10].value == 1)) 
																|| ((selectedRows[0].cells[11].value == 'Commuting' && selectedRows[0].cells[10].value != null && selectedRows[0].cells[10].value > 1 && selectedRows[0].cells[10].value < 4))))) 
																|| this.state.isConsolidationActionNo == true ? ( //RITM1216061 RITM1420951
																<TableBatchAction renderIcon={Send16} onClick={() => this.batchActionClick("Submit", "Submit", "Data Approver", true, false, selectedRows)}>
																	Submit Report
																</TableBatchAction>
															) : null}

															{CanExecuteAction(
																"Incident",
																"Reporting",
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Approve",
																this.getIncident(selectedRows)
															) ? (
																<TableBatchAction
																	renderIcon={CheckmarkOutline16}
																	onClick={() => this.batchActionClick("Approve", "Approve", "Division Manager", true, false, selectedRows)}
																>
																	Approve Report
																</TableBatchAction>
															) : null} 

															{(CanExecuteAction(
																"Incident",
																"Reporting",
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Consolidate",
																this.getIncident(selectedRows))) 
																|| (((selectedRows[0].cells[10].value !== null && (selectedRows[0].cells[10].value == 0 || selectedRows[0].cells[10].value == 1)) 
																|| ((selectedRows[0].cells[11].value == 'Commuting' && selectedRows[0].cells[10].value != null && selectedRows[0].cells[10].value > 1 && selectedRows[0].cells[10].value < 4))) 
																&& selectedRows[0].cells[0].value == 'Opened') ? ( //RITM1420951
																<TableBatchAction
																	renderIcon={CheckmarkOutline16}
																	onClick={() => this.batchActionClick("Consolidate", "Consolidate", null, false, false, selectedRows)}
																>
																	Consolidate Report
																</TableBatchAction>
															) : null}  {/*RITM1216061*/} 
															{ IsInRole(user, "Administrator") && selectedRows[0].cells[0].value == 'Completed' && selectedRows[0].cells[9].value == 1 ? (
																<TableBatchAction renderIcon={Send16} onClick={() => this.batchActionClick("Reopen", "Reopen", null, false, true, selectedRows)}>
																	Reopen Incident
																</TableBatchAction>
															) : null}  {/*RITM1216061*/} 
															{CanExecuteAction(
																"Incident",
																"Reporting",
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Reject",
																this.getIncident(selectedRows)
															) ? (
																<TableBatchAction renderIcon={Error16} onClick={() => this.batchActionClick("Reject", "Reject", null, false, true, selectedRows)}>
																	Reject Report
																</TableBatchAction>
															) : null}

															{CanExecuteAction(
																"Incident",
																"Reporting",
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"RejectConsolidate",
																this.getIncident(selectedRows)
															) ? (
																<TableBatchAction renderIcon={Error16} onClick={() => this.batchActionClick("RejectConsolidate", "Reject", null, false, true, selectedRows)}>
																	Reject Report
																</TableBatchAction>
															) : null}

															{CanExecuteAction(
																"Incident",
																"Reporting",
																user,
																selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
																"Delete",
																this.getIncident(selectedRows)
															) ? (
																<TableBatchAction renderIcon={Delete16} onClick={() => this.batchActionClick("Delete", "Delete", null, false, false, selectedRows)}>
																	Delete
																</TableBatchAction>
															) : null}
														</TableBatchActions>
													</TableToolbarContent>
												</TableToolbar>
											</Online>
										) : (
											""
										)}

										{this.state.isLoading ? (
											<DataTableSkeleton headers={[]} rowCount={skeletonRowCount} zebra={false} compact={false} />
										) : (
											<Table>
												<TableHead>
													<TableRow>
														{/* <TableSelectAll {...getSelectionProps()} /> */}
														<TableHeader className="align-center" />

															{headers.map((header) => (
																<TableHeader
																	className={`${header.type === "bool" ? "align-center" : ""} ${header.visible == "false" ? "hidden" : ""}`}
																	{...getHeaderProps({ header })}
																>
																{header.header}
															</TableHeader>
														))}
														<TableHeader className="align-center">Actions</TableHeader>
													</TableRow>
												</TableHead>
												<TableBody>
													{rows == null || rows.length == 0 ? (
														<NoRecordsPlaceholder colSpan={headers.length + 2} />
													) : (
														rows.map((row) => (
															<TableRow {...getRowProps({ row })}>
																{this.IsRowSelectable(row, selectedRows, user) ? (
																	<>
																		<Online>
																			<TableSelectRow {...getSelectionProps({ row })} />{" "}
																		</Online>
																		<Offline>
																			<TableSelectRow disabled={true} />
																		</Offline>{" "}
																	</>
																) : (
																	<TableCell key={`empty${row.id}`} className="tableActions align-center" />
																)}

																{row.cells.map((cell) => {
																	const cellHeader = headers.find((x) => x.key === cell.info.header);
																	return (
																		<RenderDataTableCell
																			className={cellHeader?.visible == "false" ? "hidden" : ""}
																			key={cell.id}
																			cell={cell}
																			header={cellHeader}
																		/>
																	);
																})}

																<TableCell key={`action-${row.id}`} className="tableActions align-center">
																	<div>
																		<Online>
																			<FileDownLoadButton
																				onError={(error) => {
																					showNotification.error(
																						`${entitiesLabels.ERROR}`,
																						getError(error, entitiesLabels.INCIDENT_NOTIFICATION, apioperation.DOWNLOAD)
																					);
																				}}
																				size="small"
																				renderIcon={DocumentExport16}
																				iconDescription="Download Notification"
																				className="bx--export-form"
																				title="Download Notification"
																				kind="ghost"
																				apiUrl={`/incident/notification/${row.id}`}
																				//fileName={`Incident_Notification_${row.incidentReportId}.pdf`}
																				fileName={this.getIncidentNotificationCode(row.id)}
																				onDownLoadStart={() => {
																					this.setState({
																						isLoadingNotificationFile: true,
																					});
																				}}
																				onDownLoadEnd={() => {
																					this.setState({
																						isLoadingNotificationFile: false,
																					});
																				}}
																			/>

																			<FileDownLoadButton
																				onError={(error) => {
																					showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT_REPORT, apioperation.DOWNLOAD));
																				}}
																				size="small"
																				className=" bx--export-tab-form"
																				renderIcon={DocumentExport16}
																				iconDescription="Download Report"
																				title="Download Report"
																				kind="ghost"
																				apiUrl={`/incident/report/${row.id}`}
																				//fileName={`Incident_Report_${row.incidentReportId}.pdf`}
																				fileName={this.getIncidentReportCode(row.id)}
																				onDownLoadStart={() => {
																					this.setState({
																						isLoadingReportFile: true,
																					});
																				}}
																				onDownLoadEnd={() => {
																					this.setState({
																						isLoadingReportFile: false,
																					});
																				}}
																			/>
																		</Online>
																		<Link to={`/incident/${row.id}`}>
																			<Button size="small" renderIcon={Edit16} iconDescription="Edit" title="Edit Incident" kind="ghost" />
																		</Link>

																		{/* <Button onClick={() => this.confirmDelete(row.id)} size="small" renderIcon={Delete16} iconDescription="Delete" kind="ghost" /> */}
																	</div>
																</TableCell>
															</TableRow>
														))
													)}
												</TableBody>
											</Table>
										)}
									</TableContainer>
								)}
							/>

							<div className="footer-pagination">
								<Pagination {...paginationProps()} />
							</div>
						</div>
					</>
				)}
			</AppContext.Consumer>
		);
	}
}
